// Curated AI artwork inspired by the previous static Explore selection.
// Display-only previews: no community metrics or generator-model claims.
export const landingExploreCards = [
  {
    id: 'landing-marina-blonde',
    imageUrl: '/assets/landing-explore-v2/marina-blonde.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title: 'Blonde woman in a white tank and linen shirt in a marina loft',
    description:
      'Sunday morning in a marina loft. A blonde woman in a white tank, open linen shirt and denim shorts smiles by the window. Keep the sunlight soft and the skin natural.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-moonlit-elf',
    imageUrl: '/assets/landing-explore-v2/moonlit-elf.webp',
    width: 640,
    height: 960,
    style: 'Fantasy',
    title: 'Silver-haired elf in burgundy and gold on a moonlit forest balcony',
    description:
      'Paint a silver-haired elven woman on a moonlit balcony, her burgundy gown covered in delicate gold embroidery. Lavender skin, amber eyes, a lantern-lit kingdom disappearing into the forest.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-sunset-sport-anime',
    imageUrl: '/assets/landing-explore-v2/sunset-sport-anime.webp',
    width: 640,
    height: 960,
    style: 'Anime',
    title: 'Anime woman in orange activewear on a rooftop at sunset',
    description:
      'Anime fitness instructor after a rooftop workout, orange crop tank and navy shorts, short dark-blue hair catching the last golden light. City skyline behind her.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-vinyl-store-blonde',
    imageUrl: '/assets/landing-explore-v2/vinyl-store-blonde.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title: 'Blonde woman in black denim browsing a warmly lit record shop',
    description:
      'A blonde woman browsing her favorite record shop at dusk. Black tee, cropped denim jacket, warm lamps between the shelves. Candid 50mm photo.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-garden-brunette',
    imageUrl: '/assets/landing-explore-v2/garden-brunette.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title:
      'Brunette in a pink summer top beside bougainvillea and a coastal harbor',
    description:
      'Make it feel like a Mediterranean summer holiday: a smiling brunette in a pink top and linen shorts, leaning beside a turquoise door, bougainvillea overhead and boats down the lane.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-festival-emo-anime',
    imageUrl: '/assets/landing-explore-v2/festival-emo-anime.webp',
    width: 640,
    height: 960,
    style: 'Anime',
    title:
      'Anime woman with split-dyed hair and a yellow jacket at a music festival',
    description:
      'Give her a split black-and-blonde bob and a yellow bomber slipping off her shoulders. Anime festival portrait, charcoal crop top, black shorts, stage lights and paper lanterns at blue hour.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-coastal-runner-v2',
    imageUrl: '/assets/landing-explore-v2/coastal-runner-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title:
      'Smiling brunette in black running clothes above a turquoise coastal cove',
    description:
      'Post-run smile on a coastal trail. Brunette ponytail, simple black activewear, turquoise water and wildflowers. Soft overcast light, a few loose strands of hair.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-midnight-rooftop-v2',
    imageUrl: '/assets/landing-explore-v2/midnight-rooftop-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title: 'Curly-haired woman in a navy sundress on a rooftop garden at dusk',
    description:
      "She's waiting on a rooftop garden as the city lights come on. Dark curls, navy sundress, gold hoops and an easy smile. Balance the cool evening with warm string lights.",
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-vinyl-studio-v2',
    imageUrl: '/assets/landing-explore-v2/vinyl-studio-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title:
      'Tattooed woman with a dark bob and black tank in a sunlit record studio',
    description:
      'Dark bob, floral tattoos, black ribbed tank. Portrait of a woman in her sunlit vinyl studio, denim jacket over one shoulder, records and leafy plants behind her.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-moonlit-arcade-anime-v2',
    imageUrl: '/assets/landing-explore-v2/moonlit-arcade-anime-v2.webp',
    width: 640,
    height: 960,
    style: 'Anime',
    title:
      'Anime woman with an indigo bob beneath lanterns on a rain-wet city street',
    description:
      'An anime woman steps out after the rain. Indigo bob, amber eyes and all-black streetwear beneath glowing paper lanterns. Let the pink shop lights reflect across the wet paving.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-glasshouse-glasses-v2',
    imageUrl: '/assets/landing-explore-v2/glasshouse-glasses-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title:
      'Woman with tortoiseshell glasses and a sketchbook in a botanical glasshouse',
    description:
      'A sketchbook afternoon at the botanical gardens. Photograph a woman in tortoiseshell glasses, a white tank and jeans among towering palms and arched glass windows.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-rainbow-canal-illustration-v2',
    imageUrl: '/assets/landing-explore-v2/rainbow-canal-portrait-v3.webp',
    width: 640,
    height: 960,
    style: 'Illustration',
    title:
      'Illustration of a woman with a multicolored bob beside a sunlit canal',
    description:
      'Teal, coral and lavender hair against a sunlit canal. Draw her in a turquoise tank and cream trousers, surrounded by flowering balconies, an old stone bridge and sparkling water.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-boardwalk-blonde-v2',
    imageUrl: '/assets/landing-explore-v2/boardwalk-blonde-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title: 'Blonde woman looking over her shoulder on a seaside boardwalk',
    description:
      'Catch a blonde woman glancing back on a seaside boardwalk. White ribbed tank, faded denim shorts, pastel beach huts. Breezy afternoon holiday snapshot.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-emerald-cove-v2',
    imageUrl: '/assets/landing-explore-v2/emerald-cove-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title: 'Blonde woman in an emerald sundress beside a turquoise cove',
    description:
      'Emerald sundress, golden bob, a little silver pendant. A cheerful woman above a clear turquoise cove with sailboats below. Natural travel photography, pale limestone and gentle sea light.',
    video: false,
    nsfw: false,
  },
  {
    id: 'landing-blue-top-night-market-v2',
    imageUrl: '/assets/landing-explore-v2/blue-top-night-market-v2.webp',
    width: 640,
    height: 960,
    style: 'Realistic',
    title:
      'Woman in a powder-blue crop tank at a night market beneath glowing string lights',
    description:
      'Night-market date, just before dark. A woman with honey-brown waves and bangs wears a powder-blue crop tank and high-waisted jeans; string lights and a Ferris wheel glow behind her.',
    video: false,
    nsfw: false,
  },
]
